import { useCallback, useMemo } from "react";

import useFileImportStore from "../../../stores/fileImportStore";

export default function useChooseCurrencyModal() {
  const handleSubmit = useCallback((values) => {
    useFileImportStore.getState().setCurrency(values.currency);
    useFileImportStore.getState().setShowChooseCurrencyModal(false);
  }, []);

  return useMemo(() => ({ handleSubmit }), [handleSubmit]);
}
